<template>
  <div>
    <invoice-application-list v-show="tabType === 1" @handleShow="handleShow" />
    <invoice-application-show v-if="tabType === 2" :row-id="detailId" :row-data="detailRow" @handleShow="handleShow" />
  </div>
</template>

<script>
import invoiceApplicationList from './list.vue'
import invoiceApplicationShow from './show.vue'

export default {
  components: {
    invoiceApplicationList,
    invoiceApplicationShow
  },
  data() {
    return {
      tabType: 1,
      detailId: null,
      detailRow: null
    }
  },
  methods: {
    handleShow(id, row) {
      if (id || row) {
        this.detailId = id || (row && row.id)
        this.detailRow = row || null
        this.tabType = 2
      } else {
        this.tabType = 1
        this.detailId = null
        this.detailRow = null
      }
    }
  }
}
</script>
